import React from 'react';
import { Text, TouchableOpacity } from 'react-native';
import TermModal from '../TermModal';
import styles from './styles';

type TermConditionProps = {
  title: string;
  content: string;
  modalTitle?: string;
};

const TermConditionButotn = ({
  title,
  content,
  modalTitle,
}: TermConditionProps) => {
  const [isShowModal, setShowModal] = React.useState(false);
  const onShowModal = () => setShowModal(true);
  const onClose = () => setShowModal(false);
  return (
    <>
      <TouchableOpacity onPress={onShowModal}>
        <Text style={styles.termCondition}>{title}</Text>
      </TouchableOpacity>
      <TermModal
        title={modalTitle}
        termsContent={content}
        isLoading={false}
        isVisible={isShowModal}
        onClose={onClose}
      />
    </>
  );
};

export default TermConditionButotn;
